import { render, staticRenderFns } from "./show-enhanced.vue?vue&type=template&id=6b0b19b6&"
import script from "./show-enhanced.vue?vue&type=script&lang=js&"
export * from "./show-enhanced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports